module.exports = __webpack_public_path__ + "img/giftCard.3968f358.png";